import { Col, Row } from 'antd'
import cx from 'classnames'
import pluralize from 'pluralize'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { frameTheatreAddress } from '../../common/util/helper'

import LoaderIcon from '../../icons/loading.svg'

class CompositionTheatreItem extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: false
    }
  }

  showKDMInfo (theatre, kdmGenerationCompleted) {
    this.setState({isLoading: true})
    this.props.showKDMInfo(theatre, kdmGenerationCompleted).then(() => {
      this.setState({isLoading: false})
    }).catch(() => {
      this.setState({isLoading: false})
    })
  }

  render () {
    const {theatre, index, cplInfo, getTheatreKdmStatus, renderKDMStatusSummary, renderDCPStatus, showKdmValidity} = this.props
    const kdmStatus = {}
    const {kdmSummary, timezone} = theatre
    const {validFrom, validTill} = kdmSummary || {}
    const showValidity = showKdmValidity(kdmSummary)
    const isTheatreKdmBooking = cplInfo.isKdmBooking && kdmSummary
    const kdmGenerationCompleted = isTheatreKdmBooking
      ? getTheatreKdmStatus(theatre, kdmStatus)
      : false
    const theatreAddress = frameTheatreAddress(theatre)
    return (
      <Row key={index}
           className={cx('theatre-border qw-font-size-small qw-line-height-small qw-color-text-body qw-mb-x-small', {'qw-pointer-none': this.state.isLoading})}>
        <Col span={6} className='qw-pl-x-large'>
          {theatre.name}
          {theatreAddress && <span
            className='block qw-font-size-x-small qw-color-text-secondary-heading'>{theatreAddress}</span>}
          {isTheatreKdmBooking &&
          <span className='block qw-font-size-x-small qw-color-text-secondary-heading'>
              {pluralize(I18n.t('compositions.screen'), theatre.screenCount, true)}</span>}
        </Col>
        {cplInfo.isDcpBooking &&
        <Col span={9} className='qw-pl-x-small'>{renderDCPStatus(theatre)}</Col>}
        {isTheatreKdmBooking &&
        <Col span={9} className='kdm-summary qw-cursor-pointer qw-pl-x-small'
             onClick={() => this.showKDMInfo(theatre, kdmGenerationCompleted)}>
          {this.state.isLoading && <span className='inline-block qw-align-middle qw-icon-x-small'>
              <LoaderIcon className='qw-icon-x-small'/></span>}
          {renderKDMStatusSummary(kdmStatus, showValidity && {
            validFrom,
            validTill,
            timezone,
            isMultiple: !validFrom && !validTill
          })}
        </Col>}
      </Row>
    )
  }
}

export default CompositionTheatreItem



// WEBPACK FOOTER //
// ./src/app/components/compositions/CompositionTheatreItem.js